import Swiper from 'swiper'

const cPostSwiperInit = () => {

    const postSwipers = document.querySelectorAll('.js-posts-swiper')

    if(postSwipers ){
        //postSwipers.forEach(fhSwiper => {
            var postSwiper = new Swiper(".js-posts-swiper", {
                slidesPerView: 'auto',
                spaceBetween: 10,
                centeredSlides: false,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    type: 'bullets',
                },
                breakpoints: {
                    767: {
                        spaceBetween: 30,
                        centeredSlides: false,
                        allowTouchMove: true
                    },
                    1024: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                        centeredSlides: false,
                        allowTouchMove: false
                    }
                }
            })
        //})
    }


}

export default cPostSwiperInit
